import { changeLangCodeForMap } from 'utils/language/convertLangCodeForMap';
import MapDraw from '../mapDraw';

export const changeMapLang = (lang: string) => {
  const langCode = changeLangCodeForMap(lang);

  MapDraw.map.context.changeLanguage(langCode);
};
